"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MediaFallback = void 0;
var _react = _interopRequireWildcard(require("react"));
var _useScaleConditional = require("@cbhq/cds-common/scale/useScaleConditional");
var _cell = require("@cbhq/cds-common/tokens/cell");
var _Fallback = require("../layout/Fallback");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const MediaFallback = /*#__PURE__*/(0, _react.memo)(function MediaFallback({
  type,
  testID
}) {
  const mediaSizeScaled = (0, _useScaleConditional.useScaleConditional)(_cell.mediaSize);
  const imageSizeScaled = (0, _useScaleConditional.useScaleConditional)(_cell.imageSize);
  if (type === 'image') {
    return /*#__PURE__*/_react.default.createElement(_Fallback.Fallback, {
      height: imageSizeScaled,
      shape: "squircle",
      testID: testID,
      width: imageSizeScaled
    });
  }
  return /*#__PURE__*/_react.default.createElement(_Fallback.Fallback, {
    height: mediaSizeScaled,
    shape: "circle",
    testID: testID,
    width: mediaSizeScaled
  });
});
exports.MediaFallback = MediaFallback;